import { Box, Grid, Tooltip, Typography } from '@mui/material';

import Copyright from './Copyright';
import LanguageSelector from '../common/LanguageSelector';

import './Footer.css';
import { useTranslation } from 'react-i18next';
import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <>
      <Box mb={2} mt={2} className="login-footer">
        <Grid container direction="row" justifyContent="center" alignItems="stretch">
          <Grid item xs={12}>
            <Box mb={1}>
              <LanguageSelector
                page={'main'}
                data-qa-element-id="language-selector" /*onLanguageChange={handleLanguageChange}*/
              />
            </Box>

            <Box mt={1.5}>
              {isPhoneOrHighScreen() && (
                <Typography
                  variant="body1"
                  component="div"
                  color="textSecondary"
                  className="footer-registration"
                  data-qa-element-id="phone_for_registration_label"
                >
                  {t('registration.body')}
                </Typography>
              )}
            </Box>
          </Grid>

          <Grid item xs={2} container justifyContent="flex-start" alignContent="center">
            {/* <PresenterIcon presenter={device.presenter} /> */}
          </Grid>

          <Grid
            item
            xs={10}
            container
            justifyContent="flex-end"
            alignContent="center"
            className="login-footer-build-id"
          >
            <Tooltip title="build ID">
              <span>
                <span className="login-footer-package-version">{VERSION}</span>
                &nbsp; b{BUILD_NUMBER}
                &nbsp; ({ENVIRONMENT})
              </span>
            </Tooltip>
            <Copyright />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Footer;
